import { render, staticRenderFns } from "./Product_Close.vue?vue&type=template&id=6890dbaf&scoped=true&"
import script from "./Product_Close.vue?vue&type=script&lang=js&"
export * from "./Product_Close.vue?vue&type=script&lang=js&"
import style0 from "./Product_Close.vue?vue&type=style&index=0&id=6890dbaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890dbaf",
  null
  
)

export default component.exports